import type { NotificationType } from '@/layers/nuxt-bbk-notification-layer/types/notification'

export interface Content {
    type: NotificationType
    message: string
    productName?: string
}

export interface Notification extends Content {
    id: number
}
export const NOTIFICATION_EVENT = {
    notification_close: 'notification:close',
} as const
